<template>
  <div>
    <el-card class="sel-member">
      <div slot="header" class="clearfix">
        <span>成员选择</span>
      </div>
      <div class="sel-cont">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="部门" name="org">
            <el-tree
              ref="orgTree"
              :props="props"
              :load="loadNode"
              show-checkbox
              check-strictly
              lazy
              icon-class="el-icon-arrow-right"
              node-key="IdentityId"
              :default-expanded-keys="[1]"
              @check-change="handleCheckOrgKeys"
              @node-click="handleNode"
            >
              <span slot-scope="{ node }" class="custom-tree-node">
                <span>
                  <!-- <i v-if="data.iconCls === 'treePositionNodeIcon'" class="el-icon-s-custom" /> -->
                  <i class="el-icon-s-custom" />{{ node.label }}</span>
              </span>
            </el-tree>
          </el-tab-pane>
          <el-tab-pane label="职位" name="depart">
            <el-tree
              :props="propsPos"
              :load="loadPos"
              show-checkbox
              check-strictly
              ref="posTree"
              lazy
              icon-class="el-icon-arrow-right"
              node-key="IdentityId"
              :default-expanded-keys="[1]"
              @node-click="handlePos"
              @check-change="handlePosChange"
            >
              <span slot-scope="{ node }" class="custom-tree-node">
                <span>
                  <!-- <i v-if="data.iconCls === 'treePositionNodeIcon'" class="el-icon-s-custom" /> -->
                  <i class="el-icon-user" />{{ node.label }}</span>
              </span>
            </el-tree>
          </el-tab-pane>
          <el-tab-pane label="用户组" name="group">
            <el-checkbox-group v-model="checkedGroups" @change="handleCheckedGroupsChange">
              <el-checkbox v-for="(group, index) in groupList" :label="group" :key="index">{{group.Name }}</el-checkbox>
            </el-checkbox-group>
          </el-tab-pane>
          <el-tab-pane label="用户" name="user">
            <el-container>
              <el-aside width="250px">
                <el-tree 
                :load="loadNode" 
                :props="props" 
                check-strictly 
                lazy 
                highlight-current 
                expand-on-click-node 
                icon-class="el-icon-arrow-right"
                node-key="IdentityId"
                :default-expanded-keys="[1]"
                @node-click="handleDepartNodeClick" />
              </el-aside>
              <el-main>
                <div class="tool-bars">
                  <el-row :gutter="20">
                    <el-col :span="16">
                      <el-input
                        v-model="searchStr"
                        placeholder="请输入账号或姓名"
                      >
                        <el-button slot="suffix" type="text" class="el-input__icon el-icon-search" @click="getUserList" />
                      </el-input></el-col>
                    <el-col :span="8"><el-checkbox v-model="isChild">包含子部门用户</el-checkbox></el-col>
                  </el-row>
                </div>
                <el-table
                  ref="userList"
                  style="width:100%"
                  height="286px"
                  :data="userList"
                  stripe
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    width="55"
                  />
                  <el-table-column
                    label="姓名"
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-user" />
                      {{ scope.row.Name + `  (${scope.row.UserLoginName})` }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="DepartmentName"
                    label="所在部门"
                  />
                  <el-table-column
                    prop="UserEmail"
                    label="Email"
                  />
                </el-table>
                <el-pagination
                  :total="pageData.Total"
                  :current-page="pageData.Index"
                  :page-sizes="[10, 20, 30, 40, 50]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-main>
            </el-container>
          </el-tab-pane>
        </el-tabs>
        <el-row v-show="checkedShow">
          <el-col :span="24" class="check-list">
            <el-tag v-for="(i, index) in allList" :key="index" type="info" closable @close="closeTag(i)">
              <i v-if="i.MemberArea === 0" class="el-icon-user" />
              <i v-if="i.MemberArea === 5" class="el-icon-grape" />
              <i v-if="i.MemberArea === 4" class="el-icon-cherry" />
              <i v-if="i.MemberArea === 3" class="el-icon-apple" />
              &nbsp;&nbsp;{{ i.Name }}</el-tag>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="check-count">已选个数: <span>{{ allList.length }}</span></div>
            <el-button type="text" :class="checkedShow?'el-icon-arrow-down':'el-icon-arrow-up'" @click="checkedShow=!checkedShow" />
          </el-col>
        </el-row>
        <div>
          <el-button type="primary" @click="addMembers()">保存</el-button>
          <el-button @click="closeAdd">取消</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'addMember',
  data() {
    return {
      activeName: 'org',
      props: {
        label: 'Name',
        isLeaf: 'leaf'
      },
      propsPos: {
        label: 'Name',
        isLeaf: 'leaf'
      },
      groupList: [],
      checkedGroups: [],
      isChild: true,
      searchStr: '',
      pageIndex: 1,
      pageSize: 10,
      userList: [],
      pageData: [],
      IdentityId: '',
      checkedShow: true,
      allList: [],
      memberList: [],
      checkDepart: [],
      checkOrg: []
    }
  },
  watch: {
    'checkOrg': function(val) {
      this.allList = val.concat(this.checkedGroups).concat(this.memberList).concat(this.checkDepart)
    },
    'checkDepart': function(val) {
      this.allList = val.concat(this.checkedGroups).concat(this.memberList).concat(this.checkOrg)
    },
    'checkedGroups': function(val) {
      this.allList = val.concat(this.memberList).concat(this.checkDepart).concat(this.checkOrg)
    },
    'memberList': function(val) {
      this.allList = val.concat(this.checkedGroups).concat(this.checkDepart).concat(this.checkOrg)
    },
  },
  created() {
    // this.getDepartByIdentId()
  },
  methods: {
    closeAdd() {
      this.$store.commit('closeModal', 'addMember')
    },
    // tab切换
    handleClick(tab, event) {
      // console.log(tab, event)
      if (tab.name === 'group') {
        this.getGroupList()
      }
    },
    // 部门树
    loadNode(node, resolve) {
      if (node.level === 0) {
        ApiService.org.getDepartByIdentId({
          token: sessionStorage.octopus_token
        }).then(res => {
          this.handleDepartNodeClick(res[0])
          return resolve(res)
        })
      }
      if (node.level > 0) {
        ApiService.org.getChildDepartByIdentId({
          token: sessionStorage.octopus_token,
          deptId: node.data.IdentityId,
          id: JSON.parse(localStorage.user).userId
        }).then(res => {
          return resolve(res)
        })
      }
    },
    // 选择部门树
    handleNode(node) {
      console.log(node)
    },
    // 获得选择的部门树列表
    handleCheckOrgKeys() {
      this.checkOrg = this.$refs.orgTree.getCheckedNodes()
      console.log(this.$refs.orgTree.getCheckedNodes())
    },
    // 职位树
    loadPos(node, resolve) {
      if (node.level === 0) {
        ApiService.org.getPosByIdentId({
          token: sessionStorage.octopus_token
        }).then(res => {
          // this.handleNode(res[0])
          return resolve(res)
        })
      }
      if (node.level > 0) {
        ApiService.org.getChildPosByIdentId({
          token: sessionStorage.octopus_token,
          positionId: node.data.IdentityId,
          positionId: node.data.IdentityId,
          id: JSON.parse(localStorage.user).userId
        }).then(res => {
          return resolve(res)
        })
      }
    },
    // 职位树节点
    handlePos(node) {
      console.log(node)
    },
    // 职位树节点变化
    handlePosChange() {
      this.checkDepart = this.$refs.posTree.getCheckedNodes()
      console.log(this.$refs.posTree.getCheckedNodes())
    },
    // 部门树节点点击
    handleDepartNodeClick(node) {
      console.log(node)
      this.IdentityId = node.IdentityId
      this.getUserList()
    },
    // 用户列表
    getUserList() {
      const params = new FormData()
      params.append('AllowDept', false)
      params.append('AllowPosition', false)
      params.append('AllowGroup', true)
      params.append('AllowMyGroup', false)
      params.append('AllowMyContact', false)
      params.append('AllowUser', true)
      params.append('SearchContent', this.searchStr)
      params.append('DeptIds', this.IdentityId)
      params.append('IsLike', true)
      params.append('page', this.pageIndex)
      params.append('rows', 10)
      params.append('IsChild', this.isChild)
      let query = {
        token: sessionStorage.octopus_token,
        index: this.pageIndex,
        size: this.pageSize,
        dataFilter: 0
      }
      ApiService.org.getUserList(query, params).then(res => {
        this.pageData = res
        this.userList = res.Info
      })
    },
    // 用户组列表
    getGroupList() {
      ApiService.org.getGroupList({
        token: sessionStorage.octopus_token,
        dataFilter: 0
      }).then(res => {
        this.groupList = res
      })
    },
    // 用户组选择框
    handleCheckedGroupsChange(value) {
      this.checkedGroups = value
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getUserList()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getUserList()
    },
    handleSelectionChange(val) {
      this.memberList = val
    },
    closeTag(tag) {
      this.allList.splice(this.allList.indexOf(tag), 1)
      if (this.checkedGroups.indexOf(tag) > -1) {
        this.checkedGroups.splice(this.checkedGroups.indexOf(tag), 1)
      } else if (this.memberList.indexOf(tag) > -1) {
        this.memberList.splice(this.memberList.indexOf(tag), 1)
        this.toggleSelection(this.userList[this.userList.indexOf(tag)])
      } else if (this.checkOrg.indexOf(tag) > -1) {
        this.checkOrg.splice(this.checkOrg.indexOf(tag), 1)
        this.$refs.orgTree.setChecked(tag.IdentityId, false)
      } else if (this.checkDepart.indexOf(tag) > -1) {
        this.checkDepart.splice(this.checkDepart.indexOf(tag), 1)
        this.$refs.posTree.setChecked(tag.IdentityId, false)
      }
    },
    toggleSelection(row) {
      this.$refs.userList.toggleRowSelection(row)
    },
    addMembers() {
      this.$store.commit('addMember', this.allList)
      this.$store.commit('closeModal', 'addMember')
    }
  }
}
</script>
<style lang="scss">
.sel-member {
  .sel-cont {
    width: 800px;
    // min-height: 480px;
    .el-tab-pane {
      height: 370px;
      overflow: auto;
    }

    .el-container {
      height: 100%;
      .el-aside {
        background: #fff;
        border: 1px solid #e6e6e6;
        padding: 0;
        margin-bottom: 0;
        overflow: auto;
      }
      .el-main {
        margin-left: 0 !important;
        border-left: 0 !important;
        overflow: hidden;
        padding: 0;
        border: 1px solid #e6e6e6;
        .tool-bars {
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;
          border-bottom: 1px solid #e6ebf5;
          padding: 0 10px;
          .el-input--medium .el-input__icon {
            line-height: 0;
          }
        }
        .el-table th, .el-table td {
          padding: 0;
        }
        .el-pagination {
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .el-tree {
      .el-tree-node__content {
        font-size: 14px;
        color: #333;
      }
      .custom-tree-node {
        i {
          margin: 0 10px;
        }
      }
    }
    .el-checkbox-group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .el-checkbox {
        margin-bottom: 5px;
      }
    }
    .el-tag {
      margin-left: 10px;
      margin-bottom: 10px;
    }
    .check-list {
      display: flex;
      margin-top: 20px;
      flex-wrap: wrap;
    }
    .check-count {
      display: inline-block;
      font-size: 14px;
      span {
        color: #409EFF;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mind/addMember.vue